export default __webpack_public_path__ + "static/media/obligeeIcon.b238810c.svg";